import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import DashboardLayout from '@/layouts/DashboardLayout'
import DashboardPage from '@/pages/dashboard/DashboardPage'
import OrdersPage from '@/pages/orders/OrdersPage'
import CustomersPage from '@/pages/customers/CustomersPage'
import CustomerDetailsPage from '@/pages/customers/CustomerDetailsPage'
import CategoriesPage from '@/pages/categories/CategoriesPage'
import TransactionsPage from '@/pages/transactions/TransactionsPage'
import AddProductPage from '@/pages/products/AddProductPage'
import AddOrderPage from '@/pages/orders/AddOrderPage'
import DiscountedCouponPage from '@/pages/discounts/DiscountedCouponPage'
import AdminRolePage from '@/pages/admin/AdminRolePage'

const router = createBrowserRouter([
  {
    path: '/',
    element: <DashboardLayout />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'orders',
        element: <OrdersPage />,
      },
      // {
      //   path: 'orders/add',
      //   element: <AddOrderPage />,
      // },
      {
        path: 'customers',
        element: <CustomersPage />,
      },
      {
        path: 'customers/:id',
        element: <CustomerDetailsPage />,
      },
      {
        path: 'categories',
        element: <CategoriesPage />,
      },
      {
        path: 'transactions',
        element: <TransactionsPage />,
      },
      {
        path: 'products/add',
        element: <AddProductPage />,
      },
      {
        path: 'discounted-coupon',
        element: <DiscountedCouponPage />,
      },
      {
        path: 'admin/role',
        element: <AdminRolePage />,
      },
    ],
  },
])

export function AppRoutes() {
  return <RouterProvider router={router} />
}